export const DgcEmblem = ({ size = 44, className = "" }) => (
  <img src="/brand/dgc-crest.png" alt="DGC — Despite Group of Companies crest" width={size} height={size}
    className={`rounded-full select-none drop-shadow-[0_6px_14px_rgba(60,35,0,.35)] ${className}`} style={{ width: size, height: size }} draggable={false} />
);

const Spread = ({ text, className }) => (
  <span className={`flex justify-between w-full ${className}`}>{[...text].map((c, i) => <span key={i}>{c === " " ? "\u00a0" : c}</span>)}</span>
);

export const Wordmark = ({ big, light }) => (
  <div className="inline-flex flex-col leading-none" data-testid="despite-wordmark">
    <Spread text="DESPITE" className={`font-display font-black gold-text gold-live ${big ? "text-3xl md:text-4xl" : "text-[26px] md:text-[30px]"}`} />
    <Spread text="GROUP OF COMPANIES" className={`font-data text-[9px] md:text-[10px] font-bold mt-1 ${light ? "text-white/75" : "text-brand-green"}`} />
  </div>
);

export const Logo = ({ size = 44 }) => (
  <div className="flex items-center gap-3" data-testid="dgc-logo">
    <DgcEmblem size={size} />
    <Wordmark />
  </div>
);
